"use client";

import { ChevronsUpDown, Lock, LogOut, User } from "lucide-react";

import { Avatar, AvatarFallback } from "@/components/ui/shadcn/avatar";
import { Button } from "@/components/ui/shadcn/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/shadcn/dropdown-menu";
import Link from "next/link";

export function NavUser({
  user,
}: {
  user: {
    username: string;
    email: string;
  };
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="link"
          className="text-gray-200 mt-6 w-full px-0 focus:outline-none"
        >
          <Avatar className="w-8 h-8 rounded-lg">
            <AvatarFallback className="rounded-full bg-gray-500">
              <User />
            </AvatarFallback>
          </Avatar>
          <div className="grid flex-1 text-sm leading-tight text-left">
            <span className="font-medium truncate">{user.username}</span>
            <span className="text-xs truncate">{user.email}</span>
          </div>
          <ChevronsUpDown className="ml-auto size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="w-(--radix-dropdown-menu-trigger-width) min-w-56 rounded-lg"
        side="bottom"
        align="end"
        sideOffset={4}
      >
        {/* <DropdownMenuLabel className="p-0 font-normal">
          <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
            <Avatar className="w-8 h-8 rounded-lg">
              <AvatarFallback className="rounded-lg">
                <User />
              </AvatarFallback>
            </Avatar>
            <div className="grid flex-1 text-sm leading-tight text-left">
              <span className="font-medium truncate">{user.username}</span>
              <span className="text-xs truncate">{user.email}</span>
            </div>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator /> */}
        <DropdownMenuGroup>
          <DropdownMenuItem>
            <Link
              href="/admin/cambiar-clave"
              className="flex items-center gap-2"
            >
              <Lock />
              Cambiar mi contraseña
            </Link>
          </DropdownMenuItem>
        </DropdownMenuGroup>
        {/* <DropdownMenuGroup>
              <DropdownMenuItem>
                <BadgeCheck />
                Account
              </DropdownMenuItem>
              <DropdownMenuItem>
                <CreditCard />
                Billing
              </DropdownMenuItem>
              <DropdownMenuItem>
                <Bell />
                Notifications
              </DropdownMenuItem>
            </DropdownMenuGroup> */}
        <DropdownMenuItem>
          <Link href="/admin/logout" className="flex items-center gap-2">
            <LogOut />
            Salir
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
